// General
import "./error-notification.scss";
// Material UI
import CloseIcon from "@mui/icons-material/Close";

const ErrorNotification = (props) => {
  const { message } = props;

  return (
    <div id="error-notification-element">
      <div className="padding-container">
        <div className="center-container">
          <div className="error-icon-container">
            <div className="error-inner-ring">
              <CloseIcon className="error-icon" />
            </div>
          </div>
        </div>

        <div className="message-body-container">
          <div className="message-body">{message}</div>
        </div>

        {false && (
          <div className="close-icon-container">
            <CloseIcon className="close-icon" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorNotification;
